import { useContext, useState } from 'react'
import { usePrevious } from 'react-use'
import { tween } from 'shifty'
import { Position } from 'types'
import { useAsyncEffect } from 'utils'
import { OVERLAY_TRANSITION_DURATION } from '../../constants'
import { UgeArtboardContext } from '../../contexts/artboard'
import { UgeCropContext } from '../../contexts/crop'

const useAnimatedCrop = (cropped: boolean): [Position, boolean] => {
    const { height, width } = useContext(UgeArtboardContext)
    const { crop } = useContext(UgeCropContext)
    const previousCropped = usePrevious(cropped)
    const noCrop: Position = { height, width, x: 0, y: 0 }
    const [animatedCrop, setAnimatedCrop] = useState<Position>(noCrop)
    const [isAnimating, setIsAnimating] = useState<boolean>(false)

    useAsyncEffect(async () => {
        if (!crop || previousCropped === undefined) {
            setAnimatedCrop(crop || noCrop)
            return
        }

        const diffX = crop.x
        const diffY = crop.y
        const diffWidth = crop.width - width
        const diffHeight = crop.height - height

        setIsAnimating(true)

        tween({
            from: { progress: cropped ? 0 : 1 },
            to: { progress: cropped ? 1 : 0 },
            duration: OVERLAY_TRANSITION_DURATION,
            easing: 'easeInOutQuart',
            render: ({ progress }) => {
                setAnimatedCrop({
                    height: height + diffHeight * progress,
                    width: width + diffWidth * progress,
                    x: diffX * progress,
                    y: diffY * progress,
                })
            },
            finish: () => {
                setIsAnimating(false)
            },
        })
    }, [cropped, height, width])

    return [animatedCrop, isAnimating]
}

export default useAnimatedCrop
